import { Alert } from '@foundation/ui'
import { useEffect, useState } from 'react'
import styles from './ToastContainer.module.css'
import type { Toast } from '@/lib/toast'
import { toast } from '@/lib/toast'

export function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    return toast.subscribe(setToasts)
  }, [])

  if (toasts.length === 0) return null

  const getVariant = (type: Toast['type']): 'success' | 'danger' | 'warning' | 'info' => {
    switch (type) {
      case 'success':
        return 'success'
      case 'error':
        return 'danger'
      case 'warning':
        return 'warning'
      case 'info':
        return 'info'
      default:
        return 'info'
    }
  }

  return (
    <div className={styles.container}>
      {toasts.map((t) => (
        <div key={t.id} className={styles.toast}>
          <Alert variant={getVariant(t.type)} className={styles.alert}>
            <span className={styles.message}>{t.message}</span>
            <button
              type="button"
              className={styles.dismiss}
              onClick={() => toast.dismiss(t.id)}
              aria-label="Dismiss"
            >
              x
            </button>
          </Alert>
        </div>
      ))}
    </div>
  )
}
